import { create } from "zustand";

type Theme = "light" | "dark" | "system";

const KEY = "crystal-ai.theme";

function apply(theme: Theme) {
  const resolved = theme === "system"
    ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
    : theme;
  document.documentElement.classList.toggle("dark", resolved === "dark");
  document.documentElement.classList.toggle("light", resolved !== "dark");
}

interface ThemeState {
  theme: Theme;
  set: (t: Theme) => void;
  toggle: () => void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: (typeof window !== "undefined" && (localStorage.getItem(KEY) as Theme)) || "light",
  set: (t) => {
    localStorage.setItem(KEY, t);
    apply(t);
    set({ theme: t });
  },
  toggle: () => {
    const next: Theme = get().theme === "dark" ? "light" : "dark";
    get().set(next);
  },
}));

if (typeof window !== "undefined") {
  apply(useTheme.getState().theme);
}
